export default {
  // Page title
  title: "站内信管理",
  stationLetter: "站内信",
  autoConfig: "自动发送配置",
  autoConfigMessage: "自动发送数据",

  // 搜索表单
  recipient: "会员帐号",
  recipientPlaceholder: "请输入会员帐号",
  subject: "标题",
  subjectPlaceholder: "请输入标题",
  status: "状态",
  statusPlaceholder: "请选择状态",
  sendTime: "操作时间",
  statisticsDate: "统计日期",
  search: "查询",
  reset: "重置",
  export: "导出",

  // 状态
  unread: "未读",
  read: "已读",
  deleted: "删除",
  
  // 任务状态
  taskStatus: "任务状态",
  statusNotSent: "未发送",
  statusSending: "发送中",
  statusSent: "已发送",
  
  // 操作相关
  operationTime: "操作时间",
  operator: "操作人",
  agentMembers: "代理会员",
  startTime: "开始时间",
  endTime: "结束时间",
  memberType: "会员类型",

  // 表格列
  content: "内容",
  language: "语言",
  receiveTime: "收到时间",
  sender: "操作人",
  messageType: "消息类型",

  // 消息提示
  exporting: "正在导出...",
  exportSuccess: "导出成功",
  exportFailed: "导出失败",
  operationFailed: "操作失败",
  requestFailed: "请求失败",

  // 其他
  seeDetails: "查看",

  // 发送站内信弹窗
  sendMessage: "发送站内信",
  language_label: "选择语言：",
  recipient_label: "会员帐号：",
  designatedMembers: "指定会员",
  allMembers: "全部会员",
  agent: "代理线下会员",
  designatedVipMembers: "指定VIP等级会员",
  directCustomers: "直客",
  importUsernames: "导入用户户名单",
  agentLabel: "*代理：",
  selectAgent: "请选择代理",
  vipLevelLabel: "VIP等级：",
  selectVipLevel: "请选择VIP等级",
  membersLabel: "选择会员：",
  memberPlaceholder: "搜索并选择会员",
  membersRequired: "请选择会员",
  usernamesLabel: "导入用户名：",
  usernamesPlaceholder: "请输入用户名，多个用户用逗号或换行分隔",
  usernamesRequired: "请输入或导入用户名",
  titleLabel: "标题：",
  titlePlaceholder: "50个字以内",
  titleRequired: "请输入标题",
  summaryLabel: "摘要",
  summaryPlaceholder: "请输入文章摘要，最多支持200个字",
  coverImageLabel: "封面图片",
  titleMaxLength: "标题不超过50个字符",
  contentLabel: "内容：",
  contentRequired: "请输入内容",
  contentMaxLength: "站内信内容字数上限为1000",
  contentCharLimit: "站内信内容字数上限为1000",
  sendSuccess: "发送成功",
  sendFailed: "发送失败",

  // 状态选项
  statusUnread: "未读",
  statusRead: "已读",
  statusDeleted: "已删除",
  
  // 目标用户计数
  targetUsers: "目标用户",
  downloadTemplate: "下载模板",

  // 消息类型
  messageType_label: "消息类型:",
  messageType_system: "系统消息",
  messageType_promos: "优惠消息",
  messageType_updates: "平台消息",

  // 自动发送配置
  autoConfigTitle: "新增自动发送模板",
  autoConfigTitle_edit: "编辑自动发送模板",
  templateCode_label: "*目标类型:",
  templateCode_placeholder: "请选择目标类型",
  templateCode_required: "请选择目标类型",
  registerUsers: "新注册用户",
  firstRechargeUsers: "首充用户",
  title_label: "标题:",
  title_placeholder: "50个字以内",
  title_required: "请输入标题",
  title_maxLength: "模板标题不超过50个字符",
  templateName_label: "*模板标题:",
  templateName_placeholder: "50个字以内",
  templateName_required: "请输入模板标题",
  templateName_maxLength: "模板标题不超过50个字符",
  recipient_type_label: "会员帐号:",
  allMembers_label: "全部会员",
  agent_label: "代理",
  agent_select_label: "*代理:",
  agent_placeholder: "请选择代理",
  agent_required: "请选择代理",
  messageType_type_label: "*消息类型:",
  messageType_placeholder: "请选择消息类型",
  messageType_required: "请选择消息类型",
  content_label: "内容:",
  content_required: "请输入内容",
  content_maxLength: "站内信内容字数上限为1000",
  autoConfig_search: "搜索",
  autoConfig_reset: "重置",
  autoConfig_add: "新增",
  autoConfig_edit: "编辑",
  autoConfig_enable: "启用",
  autoConfig_delete: "删除",
  autoConfig_disable: "禁用",
  autoConfig_templateName: "模板标题",
  autoConfig_targetType: "目标类型",
  autoConfig_status: "状态",
  autoConfig_language: "语言",
  autoConfig_content: "内容",
  autoConfig_operator: "操作人",
  autoConfig_actions: "操作",
  autoConfig_disabled: "禁用",
  autoConfig_enabled: "启用",
  autoConfig_all: "全部",
  autoConfig_enableSuccess: "启用成功",
  autoConfig_disableSuccess: "禁用成功",
  autoConfig_deleteSuccess: "删除成功",
  autoConfig_deleteFailed: "删除失败",
  autoConfig_operationFailed: "操作失败",
  autoConfig_editSuccess: "更新成功",
  autoConfig_editFailed: "更新失败",
  autoConfig_createSuccess: "创建成功",
  autoConfig_createFailed: "创建失败",
  
  // 占位符相关
  placeholder_availablePlaceholders: "可用占位符",
  placeholder_noPlaceholders: "暂无可用占位符",
  placeholder_example: "示例",
  placeholder_insertToTitle: "插入到标题",
  placeholder_insertToContent: "插入到内容",
  placeholder_tip: "提示：点击占位符可复制，悬停查看详情和插入选项",
  placeholder_copied: "已复制到剪贴板",
  placeholder_copyFailed: "复制失败",
  placeholder: {
    memberAccount_desc: "会员账号",
    currency_desc: "币种"
  },
  
  // 统计页面
  stats_serialNumber: "序号",
  stats_targetType: "目标类型",
  stats_memberType: "会员类型",
  stats_statisticsTime: "统计时间",
  stats_received: "已领取",
  stats_readCount: "已读数",
  stats_unreadCount: "未读数",
  stats_readRate: "已读率",
  startDate: "开始日期",
  endDate: "结束日期"
};
